export default "/images/vendor/flag-icons/flags/1x1/mq.svg?794f4690ac0eca38ed1072ec170190b1";